import React from 'react'
const ValidationSummary = props => {
  return props.validationErrors && props.validationErrors.length > 0 ?
    <div className="valiation-summary has-light has-background-danger has-text-white">
    <ul>
    { props.validationErrors.map(err => {
      return <li key={err.message}>
        {err.message}
        </li>
    })
    }
    </ul>

    <style jsx>{`
     .valiation-summary {
       padding: 1em;
       margin-bottom: 1em;
       border-radius: 4px;
     }
    `}</style>
    </div>
    : null
}


export default ValidationSummary

